import { useCallback, useRef, useState, ChangeEvent as ReactChangeEvent, DragEvent as ReactDragEvent } from 'react';

export function useFileUpload() {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [files, setFiles] = useState<File[]>();

  const handleChange = useCallback((event: ReactChangeEvent<HTMLInputElement>) => {
    const newFiles = [...(event.target.files || [])];
    if (!newFiles) throw new Error('File was not selected');
    setFiles(prev => [...(prev || []), ...newFiles]);
    event.target.value = '';
  }, []);

  const handleDrop = useCallback((event: ReactDragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const files = [...event.dataTransfer.files];
    if (!files) throw new Error('File was not selected');
    setFiles(files);
  }, []);

  const handleDragOver = useCallback((event: ReactDragEvent) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const handleDragEnter = useCallback((event: ReactDragEvent) => {
    event.preventDefault();
  }, []);

  const clear = useCallback(() => {
    setFiles(undefined);
  }, []);

  const trigger = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleRemoveFile = useCallback(
    (newFile: File) => {
      setFiles(files?.filter(file => !(file.name === newFile.name)));
    },
    [files]
  );

  return {
    files,
    inputRef,
    clear,
    handleChange,
    handleDrop,
    handleDragOver,
    handleDragEnter,
    handleRemoveFile,
    trigger,
  } as const;
}
